import React from 'react'
import FilterChip from 'LuxKit/Chips/FilterChip'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import SearchFormTextField from 'components/SearchV2/Components/SearchFormField/SearchFormTextField'

interface Props extends Utils.PropsWithDataAttributes {
  isOpen: boolean
  isChipMode?: boolean
  label: string
  placeholder: string
  inputValue: string
  hasSelectedData?: boolean
  formFieldRef: React.RefObject<HTMLInputElement | HTMLButtonElement | null>
  selectedItems?: number
  onClick?: () => void
  onFocus?: () => void
  handleSearchTerm?: (e: React.ChangeEvent<HTMLInputElement>) => void
  handlerClearSearchTerm?: () => void
}

function CruiseFilterFooter({
  isOpen,
  isChipMode,
  label,
  placeholder,
  inputValue,
  formFieldRef,
  selectedItems,
  onClick,
  onFocus,
  handleSearchTerm,
  handlerClearSearchTerm,
  hasSelectedData,
  ...rest
}: Props) {
  const isSelected = isOpen || !!selectedItems || hasSelectedData

  return <>
    {!isChipMode && <SearchFormTextField
      {...rest}
      ref={formFieldRef as React.RefObject<HTMLInputElement>}
      label={label}
      placeholder={placeholder}
      value={inputValue}
      displayValue={inputValue}
      onChange={handleSearchTerm}
      onClear={handlerClearSearchTerm}
      onClick={onClick}
      onFocus={onFocus}
    />}

    {isChipMode && <FilterChip
      {...rest}
      size="medium"
      onClick={onClick}
      selected={isSelected}
      endIcon={<DropdownChevron open={isOpen} />}
      ref={formFieldRef as React.RefObject<HTMLButtonElement>}
    >
      {label} {selectedItems ? `(${selectedItems})` : ''}
    </FilterChip>}
  </>
}

export default CruiseFilterFooter
